import { Badge, ThemingProps, HTMLChakraProps } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { FC, Fragment } from 'react';

import { ResourceType } from '@/enums/ResourceType';
import { useQueryParams } from '@/hooks/useQueryParams';
import { StringParam } from '@/utils/url-query-string';

import { getUnreadNotificationsQuery } from './NotificationBadge.queries';

interface INotificationBadgeProps extends HTMLChakraProps<'div'> {
  refreshInterval?: number;
  resourceType?: ResourceType | Array<ResourceType>;
  showCount?: boolean;
  positioning?: 'inline' | 'absolute';
  size?: ThemingProps<'Badge'>['size'];
}

export const NotificationBadge: FC<INotificationBadgeProps> = ({
  children,
  showCount,
  positioning = 'absolute',
  size = 'xs',
  refreshInterval = 60 * 1000,
  resourceType,
  ...rest
}) => {
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const query = getUnreadNotificationsQuery(eventId, resourceType);

  const { data, meta } = useResources(query, { refreshInterval });

  const badgeStyles =
    positioning === 'absolute'
      ? {
          top: '0.875rem',
          right: '0.875rem',
          position: 'absolute',
        }
      : null;

  return (
    <Fragment>
      {data?.length > 0 && (
        <Badge sx={{ ...badgeStyles }} size={size} {...rest}>
          {showCount && (meta?.totalUnreadCount as number)}
        </Badge>
      )}
      {children}
    </Fragment>
  );
};
